import { createReducer, on } from '@ngrx/store';
import { 
  initialInProgressDashboardState 
} from './in-progress-dashboard.state';
import * as InProgressDashboardActions from './in-progress-dashboard.actions';

export const inProgressDashboardReducer = createReducer(
  initialInProgressDashboardState,

  on(InProgressDashboardActions.loadUserTeams, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(InProgressDashboardActions.loadUserTeamsSuccess, (state, { teams }) => ({
    ...state,
    userTeams: teams,
    loading: false,
    error: null,
  })),

  on(InProgressDashboardActions.loadUserTeamsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(InProgressDashboardActions.loadDashboardData, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(InProgressDashboardActions.loadDashboardDataSuccess, (state, { userTeams, columns }) => ({
    ...state,
    userTeams,
    columns,
    loading: false,
    error: null,
    isInitialized: true,
  })),

  on(InProgressDashboardActions.loadDashboardDataFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(InProgressDashboardActions.setTeamFilter, (state, { teamIds }) => ({
    ...state,
    filters: {
      ...state.filters,
      teamIds,
    },
  })),

  on(InProgressDashboardActions.setMyAssignmentsFilter, (state, { myAssignmentsOnly }) => ({
    ...state,
    filters: {
      ...state.filters,
      myAssignmentsOnly,
    },
  })),

  on(InProgressDashboardActions.setSearchTextFilter, (state, { searchText }) => ({
    ...state,
    filters: {
      ...state.filters,
      searchText,
    },
  })),

  on(InProgressDashboardActions.updateFilters, (state, { filters }) => ({
    ...state,
    filters: {
      ...state.filters,
      ...filters,
    },
  })),

  on(InProgressDashboardActions.clearFilters, (state) => ({
    ...state,
    filters: {
      teamIds: [],
      myAssignmentsOnly: false,
      searchText: '',
    },
  })),

  on(InProgressDashboardActions.hydrateFiltersFromStorage, (state, { filters }) => ({
    ...state,
    filters: {
      ...state.filters,
      ...filters,
    },
  })),

  on(InProgressDashboardActions.initializeDashboard, (state) => ({
    ...state,
    isInitialized: true,
  }))
);